import { ManagerRole } from '../../../../../../hooks/auth/usePermissions';

export default {
  form: {
    title: 'Add manager',
    first_name: {
      label: 'First name',
      placeholder: 'Walter',
    },
    last_name: {
      label: 'Last name',
      placeholder: 'White',
    },
    city: {
      label: 'City',
      placeholder: 'Bonn',
    },
    email: {
      label: 'Email',
      placeholder: 'thedanger@foodamigos.io',
    },
    roles: {
      label: 'Role',
      placeholder: 'Select role',
      // Add-form label for store_admin sent with as_owner; other store admins keep "Admin".
      owner_option: 'Owner',
      options: {
        [ManagerRole.Admin]: 'Admin',
        [ManagerRole.Reseller]: 'Reseller',
        [ManagerRole.SalesManager]: 'Sales manager',
        [ManagerRole.SalesLeadership]: 'Sales lead',
        [ManagerRole.ContentManager]: 'Content manager',
        [ManagerRole.OnboardingManager]: 'Onboarding manager',
        [ManagerRole.MobileAppsManager]: 'Mobile apps manager',
        [ManagerRole.StoreAdmin]: 'Admin',
        [ManagerRole.StoreEmployee]: 'Employee',
        [ManagerRole.StoreOperator]: 'Operator',
        [ManagerRole.SDR]: 'SDR',
      },
      description: {
        [ManagerRole.StoreOperator]:
          '<strong>Operator:</strong> Full access to Sales, Menu, Top Items, Opening Hours, Gift Cards, Reservations, and Reports for assigned companies.',
        [ManagerRole.StoreEmployee]: '<strong>Employee:</strong> Limited access to Reservations and Gift Cards only.',
        [ManagerRole.StoreAdmin]:
          '<strong>Owner:</strong> Full access to one restaurant, including storefront, tax settings, marketing and team management. Receives an email with their login. One owner per restaurant, and other team members can’t edit or remove them.',
      },
    },
    companies: {
      label: 'Companies',
      placeholder: 'Select companies',
      owner_placeholder: 'Select restaurant',
      has_owner: 'Has an owner',
    },
  },
  fields: {
    email: 'Email',
    name: 'Name',
    roles: 'Role',
    created_at: 'Created',
    actions: 'Actions',
    companies: 'Companies',
    status: 'Status',
  },
  tags: {
    owner: 'Owner',
    operator: 'Operator',
    employee: 'Employee',
  },
  no_owner: {
    title: '{{restaurant}} has no owner',
    description: 'Anything that needs the owner waits until one is chosen.',
  },
  search: {
    placeholder: 'Search by name or email',
  },
  buttons: {
    add_manager: 'Add manager',
    actions: 'Actions',
    view_dashboard: 'View dashboard as this manager',
    login_as_manager: 'Login as this manager',
    delete: 'Delete this manager',
    resend_owner_invite: 'Resend the owner invite',
    change_owner: 'Remove {{name}} as owner',
    delete_named: 'Delete {{name}}',
    choose_owner: 'Choose an owner',
  },
  modals: {
    delete_manager: {
      title: 'Are you sure to delete {{email}} manager?',
    },
    update_manager: {
      title: 'Are you sure to update {{email}} manager?',
    },
    resend_owner_invite: {
      title: 'Resend the invite to {{email}}?',
      description: 'The owner gets a new password by email. Their current password stops working.',
    },
  },
  toasts: {
    successfully_created_manager: 'Successfully created manager',
    owner_invited: '{{email}} has been invited as the restaurant owner and will receive their login by email.',
    failed_to_load_data: 'Failed to load data, please refresh the page',
    failed_to_create_manager: 'Failed to create manager',
    failed_to_create_magic_link: 'Failed to create magic link',
    failed_to_delete_manager: 'Failed to delete manager',
    manager_got_deleted: 'Manager got deleted',
    successfully_updated_manager: 'Manager got updated',
    failed_to_update_manager: 'Failed to update manager',
    owner_invite_resent: 'The invite was sent to {{email}} again, with a new password.',
    owner_invite_resend_cooling_down: 'The invite was just resent. Wait a few minutes before sending it again.',
    failed_to_resend_owner_invite: 'Failed to resend the invite',
    owner_changed: '{{name}} is now the owner',
    owner_changed_new: '{{name}} is now the owner. Login sent to {{email}}',
    owner_removed: '{{name}} is no longer the owner',
  },
};
